import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const InputContainer = styled.div`

  .ttk-input {
    padding: 0.705em;
    font-size: 20px;
    outline: none;
    border: none;
    color: #202020;
    background-color: #f0f0f0 ;
    width: 100%;
    border-width: 2px;
    border-style: solid;
    border-color: #dedede;
    outline: none;
    margin: 10px auto;
  }
  .ttk-input[valid=false] {
      border-color: red
  }

`

export default class TInput extends React.Component {
    render() {
        /* console.log(this.props.valid) */
        return (
            <InputContainer valid={this.props.valid}>
                <input type="text" {...this.props} className={'ttk-input'} />
            </InputContainer>
        )
    }
}

TInput.propTypes = {
    valid: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/component/tinput.js